/* eslint-disable @typescript-eslint/no-explicit-any */
import DrawRight from '@/components/Category/DrawRight'
import { FilterList } from '@/components/Category/FilterList'
import { IconBack } from '@/components/Icon/HeaderIcon'
import { PageTypeSuffix } from '@/constants'
import { useRouterBack } from '@/hooks/useRouterBack'
import { IconFilter, SearchIcon } from '@/styles/Icon'
import { type Category, type Menu, type Property } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState, type Dispatch, type SetStateAction } from 'react'

type HeaderCategoryProps = {
  setIsOpenDraw: Dispatch<SetStateAction<boolean>>
  isOpenDraw: boolean
  updateParams: (params: any, routerChange?: boolean) => void
  clearFilterParams: () => void
  applyFilterParams: () => void
  activeFilters: {
    name: string
    values: string[]
  }[]
  categoryDetail: Category
  properties?: Property[]
  categoryMenu: Menu[]
  sortOptions: any
  activeSort: any
  activeSortCustom: string[]
}
export const HeaderCategory = ({
  setIsOpenDraw,
  isOpenDraw,
  properties,
  updateParams = () => false,
  activeFilters,
  clearFilterParams,
  applyFilterParams,
  categoryDetail,
  categoryMenu,
  sortOptions,
  activeSort = '',
  activeSortCustom = [''],
}: HeaderCategoryProps) => {
  const router = useRouter()
  const [scrollY, setScrollY] = useState(0)
  const [, setSelectedValue] = useState<string[]>([])
  const handleGoBack = useRouterBack()
  const handleClearFilter = () => {
    clearFilterParams()
  }
  const handleApplyFilter = () => {
    applyFilterParams()
    setIsOpenDraw(false)
  }
  const handleScroll = () => {
    setScrollY(document.documentElement.scrollTop)
  }
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll)
      return () => window.removeEventListener('scroll', handleScroll)
    }
  })
  const subMenu = categoryMenu?.filter(e => e.objId == categoryDetail?._id)
  const parentMenu = categoryMenu?.filter(
    e => e.objId == categoryDetail?.parentId
  )

  useEffect(() => {
    const checkSortActive = sortOptions
      .filter((e: any) => e.type == 'custom')
      .map((item: any) => {
        if (activeSortCustom.includes(item.name)) {
          return item
        }
        return null
      })
      .filter(Boolean)
    setSelectedValue(checkSortActive)
  }, [])
  useEffect(() => {
    if (activeSort) {
      return setActiveSortButton(activeSort)
    }
    return setActiveSortButton('')
  }, [activeSort, router])
  useEffect(() => {
    const element = document.getElementById('activeMn')
    if (element && element.offsetLeft >= 400) {
      document?.getElementById('menuMb')?.scrollTo({
        left: element.offsetLeft - 200,
      })
    }
  })

  const onPriceSort = (name: string) => {
    setActiveSortButton(name)
    if (name == activeSortButton) {
      setActiveSortButton('')
      return updateParams(
        [
          {
            name: 'sortBy',
            value: null,
          },
          {
            name: 'sortType',
            value: null,
          },
        ],
        false
      )
    }
    return updateParams(
      [
        {
          name: 'sortBy',
          value: 'calMediaPrice',
        },
        {
          name: 'sortType',
          value: name,
        },
      ],
      false
    )
  }

  const [activeSortButton, setActiveSortButton] = useState('')
  return (
    <div
      className={`sticky left-0 top-0 z-[999] mb-2 w-full bg-primary-base ${
        scrollY > 25 ? ' shadow-bottom' : ''
      }`}
    >
      <div
        className={`flex h-[60px] w-full items-center justify-between gap-2 px-2`}
      >
        <div className='relative max-w-[40px] flex-[40px]'>
          <button
            className='relative z-10 flex h-10 w-10 cursor-pointer items-center justify-center outline-none'
            onClick={() => handleGoBack(true)}
          >
            <IconBack />
          </button>
        </div>
        <Link
          href={'/search'}
          className='flex h-[40px] w-full flex-1 items-center justify-between gap-2 overflow-hidden rounded-lg bg-white py-2 pl-3 pr-4'
        >
          <SearchIcon />
          <span className='flex-1 text-sm text-gray-900'>
            Bạn cần tìm gì hôm nay?
          </span>
        </Link>
        <div className='relative max-w-[32px] flex-[32px] justify-end '>
          <button
            className='flex h-10 w-full items-center justify-end gap-0.5 text-left outline-none'
            onClick={() => setIsOpenDraw(true)}
          >
            <IconFilter />
          </button>
        </div>
      </div>
      <div className='menuWrapper overflow-hidden'>
        <div
          id='menuMb'
          className='catMenu hiddenScrollBar scrollBarXCS flex snap-x items-center overflow-x-auto overflow-y-hidden scroll-smooth px-2 pt-1'
        >
          {categoryMenu &&
            categoryMenu.map((item, index) => {
              return (
                <Link
                  id={`${
                    router.query.slug == item.slug + PageTypeSuffix.CATEGORY
                      ? 'activeMn'
                      : ''
                  }`}
                  className={`item mr-1 block h-8 w-max whitespace-nowrap rounded-full text-sm leading-8 text-white outline-none ${
                    router.query.slug == item.slug + PageTypeSuffix.CATEGORY
                      ? 'activeMn bg-white px-7 font-bold !text-primary-dark'
                      : 'px-2'
                  } ${
                    categoryDetail.parentId == item.objId
                      ? 'font-bold !text-primary-second'
                      : ''
                  }`}
                  key={index}
                  href={'/' + item.slug + PageTypeSuffix.CATEGORY}
                >
                  {getTranslate(item.name)}
                </Link>
              )
            })}
        </div>
        <div className='subMenu'>
          {subMenu && subMenu.length > 0 && subMenu[0].children ? (
            <div className='catMenu hiddenScrollBar scrollBarXCS flex snap-x items-center overflow-x-auto overflow-y-hidden pb-2'>
              {subMenu &&
                subMenu[0] &&
                subMenu[0].children.map((item, index) => {
                  return (
                    <Link
                      className={`item mr-1 block h-7 w-max whitespace-nowrap rounded-full text-sm leading-7 text-dark-800 outline-none ${
                        router.query.slug == item.slug + PageTypeSuffix.CATEGORY
                          ? 'snap-center bg-red-600 px-4 font-bold !text-white'
                          : 'px-2'
                      } ${
                        categoryDetail.parentId == item.objId
                          ? 'snap-center font-bold !text-primary-second'
                          : ''
                      }`}
                      key={index}
                      href={'/' + item.slug + PageTypeSuffix.CATEGORY}
                    >
                      {getTranslate(item.name)}
                    </Link>
                  )
                })}
            </div>
          ) : (
            <div className='catMenu hiddenScrollBar scrollBarXCS mt-1 flex snap-x items-center overflow-x-auto overflow-y-hidden px-2 pb-2'>
              {parentMenu &&
                parentMenu[0] &&
                parentMenu[0].children.map((item, index) => {
                  return (
                    <Link
                      className={`item mr-1 block h-7 w-max whitespace-nowrap rounded-full text-sm leading-7 text-dark-800 outline-none ${
                        router.query.slug == item.slug + PageTypeSuffix.CATEGORY
                          ? 'snap-center bg-red-600 px-4 font-bold !text-white'
                          : 'px-2'
                      } ${
                        categoryDetail.parentId == item.objId
                          ? 'snap-center font-bold !text-primary-second'
                          : ''
                      }`}
                      key={index}
                      href={'/' + item.slug + PageTypeSuffix.CATEGORY}
                    >
                      {getTranslate(item.name)}
                    </Link>
                  )
                })}
            </div>
          )}
        </div>
      </div>
      <DrawRight
        open={isOpenDraw}
        onClose={() => setIsOpenDraw(false)}
        title={'Bộ lọc tìm kiếm'}
        type='filter'
      >
        <div className='cateSideBar hiddenScrollBar scrollBarXCS mr-2 h-full max-h-[calc(100svh-160px)] overflow-y-auto pl-3 pr-1'>
          {properties &&
            properties.map((e: Property) => {
              return (
                e &&
                e?.values &&
                e?.values?.length > 0 && (
                  <FilterList
                    key={e._id}
                    filterGroup={e}
                    activeFilters={activeFilters}
                    onChange={updateParams}
                    className='mb-2'
                    title={getTranslate(e.displayName)}
                  />
                )
              )
            })}
          <div className='sort'>
            <div className='title mb-2'>
              <span className='text-sm font-bold text-dark-400'>Sắp xếp</span>
            </div>
            <div className='mb-8 grid grid-cols-2'>
              {sortOptions &&
                sortOptions
                  .filter((item: any) => item.type == 'sortType')
                  .map((e: any, index: number) => (
                    <div
                      className='form-check-filter box-radio w-full gap-2 rounded bg-white py-2 pr-5'
                      key={`sort-${index}`}
                    >
                      <input
                        className='form-radio-input'
                        id={e.name}
                        type='radio'
                        defaultChecked={activeSortButton == e.name}
                        name={'shipping-address'}
                        onClick={() => onPriceSort(e.name)}
                      />
                      <label
                        className='form-radio-label flex w-full flex-wrap'
                        htmlFor={e.name}
                      >
                        <span className='block h-full align-super text-sm text-dark-400'>
                          {e.label}
                        </span>
                      </label>
                    </div>
                  ))}
            </div>
          </div>
        </div>
        <div className='footerDraw absolute bottom-0 right-0 z-10 flex h-[88px] w-full justify-center bg-white px-[12%] pt-4 text-base shadow-100'>
          <button
            className=' flex h-[48px] w-full flex-wrap content-center items-center justify-center rounded-l-lg border-none bg-dark-900 text-white-400'
            onClick={handleClearFilter}
          >
            Thiết lập lại
          </button>
          <button
            className='flex h-[48px] w-full flex-wrap content-center items-center justify-center rounded-r-lg border-none bg-primary-base text-white-400'
            onClick={handleApplyFilter}
          >
            Áp dụng
          </button>
        </div>
      </DrawRight>
    </div>
  )
}
